// extracted by mini-css-extract-plugin
module.exports = {"pillars":"Pillars_pillars__Pk1l9","pillars__item":"Pillars_pillars__item__rKIZn"};